class SessionManager {
  constructor() {
    this.SESSION_KEY = 'recipe_session';
    this.IP_KEY = 'user_ip';
    this.RESULT_KEY = 'last_recipe_result';
  }

  // Получаем IP пользователя
  async getUserIP() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Ошибка при получении IP:', error);
      return null;
    }
  }

  // Проверяем, может ли пользователь сделать запрос
  async canMakeRequest() {
    const storedSession = localStorage.getItem(this.SESSION_KEY);
    const storedIP = localStorage.getItem(this.IP_KEY);
    const currentIP = await this.getUserIP();

    // Если нет сохранённой сессии или IP - можно делать запрос
    if (!storedSession || !storedIP) {
      return true;
    }

    // Если IP изменился - можно делать запрос
    if (storedIP !== currentIP) {
      return true;
    }

    // Если есть сохранённая сессия и IP совпадает - запрос запрещён
    return false;
  }

  // Сохраняем информацию о сессии
  async saveSession(recipeResult) {
    const currentIP = await this.getUserIP();
    const sessionData = {
      timestamp: Date.now(),
      ip: currentIP
    };

    localStorage.setItem(this.SESSION_KEY, JSON.stringify(sessionData));
    localStorage.setItem(this.IP_KEY, currentIP);
    localStorage.setItem(this.RESULT_KEY, JSON.stringify(recipeResult));
  }

  // Получаем сохранённый результат
  getSavedResult() {
    const result = localStorage.getItem(this.RESULT_KEY);
    return result ? JSON.parse(result) : null;
  }

  // Проверяем, есть ли сохранённый результат
  hasSavedResult() {
    return !!localStorage.getItem(this.RESULT_KEY);
  }
}

export const sessionManager = new SessionManager(); 